import Flex from '@components/Flex/Flex';
import Text from '@components/Text/Text';
import { TabType } from '@features/api/response/tabContent/TabType';
import { useTabData } from '@hooks/useTabData';
import { Box, useTheme } from '@mui/material';
import {
  Feature,
  Highlights as HighlightsContents,
} from '@features/api/response/tabContent/Highlights';
import {
  ImageContainer,
  StyledContainer,
  StyledImage,
  StyledItem,
  TextContainer,
} from './Highlights.styles';
import { Button, Loader, SequentialBlock, SlidingPanel } from '@components';
import { FormattedMessage } from 'react-intl';
import { useState } from 'react';

const Highlights: React.FC = () => {
  const theme = useTheme();

  const {
    data: highlights,
    isFetching,
    isLoading,
  } = useTabData<HighlightsContents>(TabType.WHY_SFPE);

  const [panelContent, setPanelContent] = useState<Feature | undefined>();

  if (isFetching || isLoading) {
    return <Loader isLoading />;
  }
  return (
    <>
      <StyledContainer>
        {highlights?.features.map((x) => (
          <StyledItem key={x.name}>
            <ImageContainer>
              <StyledImage key={x.icon} src={x.icon} />
            </ImageContainer>
            <TextContainer>
              <Text variant='h4' fontWeight='fontWeightBold'>
                {x.name}
              </Text>
              <Text
                variant='bodyBig'
                fontWeight='fontWeightRegular'
                color={theme.palette.black.A100}
                mt={6}
                flex={1}
              >
                {x.description}
              </Text>
              <Box flex={1} display='flex' alignItems='flex-end' mt={6}>
                <Button variant='secondary' onClick={() => setPanelContent(x)}>
                  <FormattedMessage id='misc.learnMore' />
                </Button>
              </Box>
            </TextContainer>
          </StyledItem>
        ))}
      </StyledContainer>
      <SlidingPanel
        PaperProps={{ sx: { width: 500 } }}
        anchor='right'
        title={panelContent?.name}
        open={!!panelContent}
        onClose={() => setPanelContent(undefined)}
      >
        {panelContent?.details?.blocks.map(({ key, ...restProps }) => (
          <Flex mt={12} key={restProps.sequenceNumber}>
            <SequentialBlock {...restProps} />
          </Flex>
        ))}
      </SlidingPanel>
    </>
  );
};

export default Highlights;
